__turbopack_context__.v({
  "modalContent": "B2bFormModal-module-scss-module__OkKYTG__modalContent",
});
